import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'vehicle',
    initialState: {
        isRequesting: false,
        error: null,
        isDone: false,
        data: null,
    },
    reducers: {
        create_vehicle: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        delete_vehicle: (state) =>{
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        update_vehicle: (state) =>{
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        delete_vehicle_failed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        update_vehicle_failed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        create_vehicle_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        delete_vehicle_succeed: (state) =>{
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        update_vehicle_succeed: (state) =>{
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        create_vehicle_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                data: action.payload
            };
        },
        export_vehicle: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                data: action.payload
            };
        },
    }
});

export const { reducer, actions } = slice;

export default reducer;